module.exports = __webpack_public_path__ + "static/media/background-shade01.da8d58a0.svg";